import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { notasEnvioApi } from '../../api/remitos'
import EstadoVigenteBadge from '../../components/EstadoVigenteBadge'
import { fmtFecha, fmtHora } from '../../utils/fecha'
import { colors, font, text } from '../../design/tokens'
import { Seccion, Dato, Cargando, ErrorMsg, DocTag, LinkMapa, ViajesSeccion } from './comunes'

// Detalle móvil de una nota de envío — solo lectura. GET /notas-envio/{id}.
export default function MovilNeDetalle() {
  const { id } = useParams()
  const navigate = useNavigate()
  const [ne, setNe] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    notasEnvioApi.obtener(id)
      .then(({ data }) => setNe(data))
      .catch(() => setError('No se pudo cargar la nota de envío.'))
  }, [id])

  if (error) return <ErrorMsg>{error}</ErrorMsg>
  if (!ne) return <Cargando />

  const dest = ne.destinatario || {}
  const direccion = [
    dest.calle,
    dest.piso && `piso ${dest.piso}`,
    dest.depto && `depto ${dest.depto}`,
    dest.localidad, dest.provincia, dest.codigo_postal,
  ].filter(Boolean).join(', ')

  return (
    <div>
      <div style={{ margin: '4px 0 2px', display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <DocTag tipo="ne" numero={ne.numero_ne} />
        <span style={{ flex: 1 }} />
        {ne.estado_vigente
          ? <EstadoVigenteBadge estadoVigente={ne.estado_vigente} />
          : <span style={estadoRaw}>{ne.estado}</span>}
      </div>

      <Seccion titulo="Destinatario">
        <div style={{ fontFamily: font.sans, fontWeight: 600, fontSize: 15, color: colors.text, marginBottom: 4 }}>
          {dest.nombre || '—'}
        </div>
        <Dato label="Dirección">{direccion || '—'}</Dato>
        {dest.telefono && <Dato label="Teléfono" mono>{dest.telefono}</Dato>}
        {ne.zona && <Dato label="Zona">{ne.zona.nombre}</Dato>}
        {ne.fecha_entrega_est && <Dato label="Fecha estimada" mono>{fmtFecha(ne.fecha_entrega_est)}</Dato>}
        {(ne.hora_desde || ne.hora_hasta) && (
          <Dato label="Horario" mono>
            {ne.hora_desde && ne.hora_hasta ? `${fmtHora(ne.hora_desde)} – ${fmtHora(ne.hora_hasta)}` : fmtHora(ne.hora_desde || ne.hora_hasta)}
          </Dato>
        )}
        <LinkMapa dir={direccion} />
        {dest.notas && <p style={nota}>📝 {dest.notas}</p>}
      </Seccion>

      {/* Viajes de la NE: con qué salida salió y cómo terminó cada intento */}
      <ViajesSeccion
        docs={ne.salida_documentos || ne.salidaDocumentos}
        onVerSalida={(sid) => navigate(`/m/reparto/${sid}`)}
      />

      {ne.remito && (
        <Seccion titulo="Remito padre">
          <Dato label="Remito">
            <button onClick={() => navigate(`/m/logistica/remito/${ne.remito.id}`)} style={linkBtn}>
              {ne.remito.numero_presea} →
            </button>
          </Dato>
          <Dato label="Cliente">{ne.remito.cliente?.nombre || '—'}</Dato>
        </Seccion>
      )}

      <Seccion titulo={`Artículos (${ne.articulos?.length || 0})`}>
        {(ne.articulos || []).length === 0 ? (
          <p style={nota}>Sin artículos cargados.</p>
        ) : (
          <>
            {ne.articulos.map((a, i) => (
              <div key={i} style={{ display: 'flex', justifyContent: 'space-between', gap: 10, padding: '6px 0', borderBottom: `1px solid ${colors.borderSoft}` }}>
                <span style={{ fontSize: text.body, color: colors.text, fontFamily: font.sans, minWidth: 0 }}>
                  {(a.articulo?.factura_como || a.articulo)?.descripcion || '—'}
                </span>
                <span style={{ fontFamily: font.mono, fontVariantNumeric: 'tabular-nums', fontSize: 13, fontWeight: 700, color: colors.text, flexShrink: 0 }}>
                  {Number(a.cantidad)}
                </span>
              </div>
            ))}
            <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 8 }}>
              <span style={{ fontSize: text.sec, fontWeight: 700, color: colors.textSec }}>Total unidades</span>
              <span style={{ fontFamily: font.mono, fontVariantNumeric: 'tabular-nums', fontSize: 13.5, fontWeight: 700, color: colors.text }}>
                {ne.articulos.reduce((acc, a) => acc + Number(a.cantidad || 0), 0)}
              </span>
            </div>
          </>
        )}
      </Seccion>
    </div>
  )
}

const estadoRaw = {
  padding: '2px 8px', borderRadius: 4, fontSize: 11, fontWeight: 600, textTransform: 'uppercase',
  background: colors.borderSoft, color: colors.textSec,
}
const nota = { margin: '8px 0 0', fontSize: text.sec, color: colors.textSec, fontFamily: font.sans, lineHeight: 1.45 }
const linkBtn = {
  border: 'none', background: 'transparent', color: colors.link, fontFamily: font.mono,
  fontVariantNumeric: 'tabular-nums', fontSize: 13, fontWeight: 600, cursor: 'pointer', padding: 0,
}
